import { ReactNode } from "react";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import Text from "@/shared/typography/text";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";
import { ParticipantStatus } from "../model/get-participant-status";

const STATUS_CONFIG: Record<
  ParticipantStatus,
  {
    label: string;
    color: "success" | "warning" | "secondary";
    icon?: ReactNode;
  }
> = {
  [ParticipantStatus.SignedDigital]: {
    label: "Signed with digital signature",
    color: "success",
    icon: <CheckCircleOutlined />,
  },
  [ParticipantStatus.Reviewed]: {
    label: "Reviewed status",
    color: "success",
    icon: <CheckCircleOutlined />,
  },
  [ParticipantStatus.AwaitingSignature]: {
    label: "Awaiting signature",
    color: "warning",
    icon: <ClockCircleOutlined />,
  },
  [ParticipantStatus.NotReviewed]: {
    label: "Not reviewed",
    color: "secondary",
    icon: <MinusCircleOutlined />,
  },
  [ParticipantStatus.NotRequired]: {
    label: "Not required status",
    color: "secondary",
    icon: <MinusCircleOutlined />,
  },
};

export function ParticipantStatusLabel({
  status,
}: {
  status: ParticipantStatus;
}) {
  const t = useDocumentsTranslations();
  const { label, color, icon } = STATUS_CONFIG[status];

  return (
    <Text color={color} className="inline-flex items-center gap-1">
      {t(label)}
      {icon}
    </Text>
  );
}
